import React, { FunctionComponent } from 'react'

import {
  StyledButtonRow,
  StyledDescription,
  StyledNotFound,
  StyledNotFoundButton,
  StyledNotFoundContainer,
  StyledTitle,
  StyledTitleRow,
  StyledTitleValue
} from './NotFound.styles'
import { TypographyVariant } from '../../components/ClinText/ClinText.styles'
import { ClinTheme } from '../../ClinTheme'
import { ClinButton } from '../../components/ClinButton'
import { ClinIcon } from '../../components/ClinIcon'
import { ClinIconPathName } from '../../components/ClinIcon/ClinIcon.paths'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'

interface INotFoundProps {
  /** Search value */
  searchInput?: string
  viewProductsButton?: boolean
}

export const NotFound: FunctionComponent<INotFoundProps> = (props) => {
  const { searchInput, viewProductsButton } = props
  const { t } = useTranslation()
  const history = useHistory()

  const handleRequestDrug = () => {
    history.push('/sourcing-enquiry')
  }

  const handleViewProducts = () => {
    history.push('/products/catalogue')
  }

  return (
    <StyledNotFound>
      <StyledNotFoundContainer>
        <StyledTitleRow>
          <StyledTitle
            as="span"
            variant={TypographyVariant.LargerParagraph}
            color={ClinTheme.colors.black}
          >
            {t('home:not_found_title')}
          </StyledTitle>
          {searchInput && (
            <StyledTitleValue
              as="span"
              variant={TypographyVariant.LargerParagraph}
              color={ClinTheme.colors.black}
            >
              &#39;{searchInput}&#39;
            </StyledTitleValue>
          )}
        </StyledTitleRow>
        <StyledDescription as="div" color={ClinTheme.colors.black}>
          {t('home:not_found_description')}
        </StyledDescription>
        <StyledButtonRow>
          <ClinButton
            type="button"
            variant="primary"
            onClick={handleRequestDrug}
          >
            {t('home:request_drug')}
          </ClinButton>
          {viewProductsButton && (
            <StyledNotFoundButton
              type="button"
              variant="secondary"
              onClick={handleViewProducts}
            >
              {t('home:view_products')}
              <ClinIcon
                iconName={ClinIconPathName.ArrowRight}
                iconSize={20}
                style={{ marginLeft: ClinTheme.space[2] }}
              />
            </StyledNotFoundButton>
          )}
        </StyledButtonRow>
      </StyledNotFoundContainer>
    </StyledNotFound>
  )
}
